export const TOGGLE_OPEN = 'chat-toggle-open';
export const CLOSE = 'chat-close';
export const SET_INPUT = 'chat-set-input';
export const SEND_MESSAGE = 'chat-send-message';
export const RECEIVE_START = 'chat-receive-start';
export const RECEIVE_CHUNK = 'chat-receive-chunk';
export const RECEIVE_THINKING = 'chat-receive-thinking';
export const PROMOTE_THINKING = 'chat-promote-thinking';
export const RECEIVE_DONE = 'chat-receive-done';
export const RECEIVE_ERROR = 'chat-receive-error';
export const RECEIVE_RUN_UPDATE = 'chat-receive-run-update';
export const RECEIVE_ELEMENT = 'chat-receive-element';
export const CLEAR_CONTEXT = 'chat-clear-context';
export const RECEIVE_CONTEXT = 'chat-receive-context';
export const RECEIVE_STARTERS = 'chat-receive-starters';
export const RECEIVE_SKILL = 'chat-receive-skill';
export const STOP = 'chat-stop';
export const SET_STREAMING_MODE = 'chat-set-streaming-mode';

export const toggleChatPanel = props => ({ ...props, type: TOGGLE_OPEN });
export const closeChat = props => ({ ...props, type: CLOSE });
export const setChatInput = props => ({ ...props, type: SET_INPUT });
export const sendChatMessage = props => ({ ...props, type: SEND_MESSAGE });
export const receiveChatStart = props => ({ ...props, type: RECEIVE_START });
export const receiveChatChunk = props => ({ ...props, type: RECEIVE_CHUNK });
export const receiveChatThinking = props => ({ ...props, type: RECEIVE_THINKING });
export const promoteChatThinking = props => ({ ...props, type: PROMOTE_THINKING });
export const receiveChatDone = props => ({ ...props, type: RECEIVE_DONE });
export const receiveChatError = props => ({ ...props, type: RECEIVE_ERROR });
export const receiveChatRunUpdate = props => ({ ...props, type: RECEIVE_RUN_UPDATE });
export const receiveChatElement = props => ({ ...props, type: RECEIVE_ELEMENT });
export const clearChatContext = props => ({ ...props, type: CLEAR_CONTEXT });
export const receiveChatContext = props => ({ ...props, type: RECEIVE_CONTEXT });
export const receiveChatStarters = props => ({ ...props, type: RECEIVE_STARTERS });
export const receiveChatSkill = props => ({ ...props, type: RECEIVE_SKILL });
export const stopChat = props => ({ ...props, type: STOP });
export const setStreamingMode = props => ({ ...props, type: SET_STREAMING_MODE });
